export default __webpack_public_path__ + "static/media/StupendousSound_01.1b21a65a.png";